<template>
    <div>
        <div class="bg-white p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Packages Sent</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalMonthlyPackage}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsMonthlyPackage}}%</p>
            </div>
            
        </div>

        <div class="bg-white mt-4 p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Buy for me orders</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalMonthlyBuyForMe}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsMonthlyBuyForMe}}%</p>
            </div>
        </div>

        <div class="bg-white mt-4 p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Haulage orders</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalMonthlyHaulage}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsMonthlyHaulage}}%</p>
            </div>
        </div>

        <div class="bg-white mt-4 p-2">
            <div class="flex justify-between">
                <div class="flex">
                    <img class="border bg-gray-200 p-1 rounded-lg" src="../assets/analyt-icon.svg" alt="icon">
                    <p class="ml-2">Total Ride orders</p>
                </div>
                <div class="text-xl text-blue-600 font-bold ml-6">
                    <p>{{totalMonthlyRide}}</p>
                </div>
            </div>
            <div class="flex justify-end">
                <img src="../assets/analyt-icon2.svg" alt="icon">
                <p class="text-green-500">{{statsMonthlyRide}}%</p>
            </div>
        </div>

        
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            totalMonthlyHaulage : "",
            totalMonthlyPackage : "",
            totalMonthlyBuyForMe : "",
            totalMonthlyRide: "",

            statsMonthlyHaulage : "",
            statsMonthlyPackage : "",
            statsMonthlyBuyForMe : "",
            statsMonthlyRide: "",
            token: localStorage.getItem("token")
        }
    },

    mounted() {
        this.getMonthlyTotalHaulage();  
        this.getMonthlyTotalPackage(); 
        this.getMonthlyBuyForMe();  
        this.getMonthlyTotalRide();
    },

    methods: {
        getMonthlyTotalPackage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=package&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data;
                this.totalMonthlyPackage = total.total;
                this.$store.commit('totalMonthlyPackage', this.totalMonthlyPackage);
                this.statsMonthlyPackage = total.stats;
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyBuyForMe() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=buyForMe&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data;
                this.totalMonthlyBuyForMe = total.total;
                this.$store.commit('totalMonthlyBuyForMe', this.totalMonthlyBuyForMe);
                this.statsMonthlyBuyForMe = total.stats;
            })
            .catch((error) => {
                console.log(error)
            })
        },
        getMonthlyTotalHaulage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=haulage&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data;
                this.totalMonthlyHaulage = total.total;
                this.$store.commit('totalMonthlyHaulage', this.totalMonthlyHaulage)
                this.statsMonthlyHaulage = total.stats;
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyTotalRide(totalRide) {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=bookARide&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data;
                this.totalMonthlyRide = total.total;
                totalRide = total.total
                this.$store.commit('totalMonthlyRide', totalRide);
                this.statsMonthlyRide = total.stats;
            })
            .catch((error) => {
                console.log(error)
            })
        },

        

    }
}
</script>